const IMPORT_EMPLOYEES = 'employeeMaster/IMPORT_EMPLOYEES';
const EXPORT_EMPLOYEES = 'employeeMaster/EXPORT_EMPLOYEES';
const IMPORT_SUCCESS = 'employeeMaster/IMPORT_SUCCESS';
const IMPORT_FAILURE = 'employeeMaster/IMPORT_FAILURE';
const EXPORT_SUCCESS = 'employeeMaster/EXPORT_SUCCESS';
const EXPORT_FAILURE = 'employeeMaster/EXPORT_FAILURE';
const TOTAL_EMPLOYEE_BY_SURVEY = 'employeeMaster/EMPLOYEE_COUNT';

const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  employeeCount: 0,
  urlNullCount: 0,
};

export const setEmployeeMaster = (count) => ({
  type: TOTAL_EMPLOYEE_BY_SURVEY,
  payload: count,
});


const employeeMaster = (state = initialState, action) => {
  switch (action.type) {
    case IMPORT_EMPLOYEES:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };
    case IMPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: 'Employee data imported successfully.',
        error: null,
      };
    case IMPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        successMessage: null,
      };
    case EXPORT_EMPLOYEES:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };
    case EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: 'Employee data exported successfully.',
        error: null,
      };
    case EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        successMessage: null,
      };
    case TOTAL_EMPLOYEE_BY_SURVEY:
      return {
        ...state,
        loading: false,
        employeeCount: action.payload,
        error: null,
      };
    default:
      return state;
  }
}
export default employeeMaster;
export const importEmployees = () => ({ type: IMPORT_EMPLOYEES });
export const exportEmployees = () => ({ type: EXPORT_EMPLOYEES });



// WEBPACK FOOTER //
// ./src/redux/modules/empolyeeMaster.js